<ng-container [ngSwitch]="type">
  <ng-container *ngSwitchCase="'address'">
    <p class="rs-tit4 rs-word-break-all">
      <span class="rs-flex">
        <span class="rs-padding-right1"
          ><i class="icon-Place-map icon-lh" aria-hidden="true"></i
        ></span>
        {{ label }}
      </span>
    </p>
  </ng-container>
  <ng-container *ngSwitchCase="'mobile'">
    <p
      class="rs-tit4 rs-word-break-all"
      *ngIf="hasDivisionIdentifierAtFirstPosition; else hasAnotherPosition"
    >
      <span class="rs-flex">
        <span class="rs-padding-right1">
          <i
            class="icon-Smartphone icon-lh rs-margin-right1"
            aria-hidden="true"
          ></i>
        </span>
        {{ label }}
      </span>
    </p>
    <ng-template #hasAnotherPosition>
      <p class="rs-txt-s5 rs-padding-bottom2">
        <i
          class="icon-Smartphone icon-lh rs-margin-right1"
          aria-hidden="true"
        ></i>
        {{ label }}
      </p>
    </ng-template>
  </ng-container>
  <ng-container *ngSwitchCase="'other'">
    <p class="rs-tit4 rs-padding-bottom1">{{ label }}</p>
    <p class="rs-txt-details">
      {{ 'bills.cover.otherTooltipText' | translate }}
    </p>
  </ng-container>
</ng-container>
